import React from "react";
import NVHorizontalBarChart, {
  formats,
} from "common/graphs/NVHorizontalBarChart";
import styled from "styled-components";
import { useBqnId } from "common/BqnContext";

const UsageGraphLayout = styled.div`
  h4 {
    text-align: center;
    &.align-left {
      text-align: left;
    }
  }
  .centered {
    text-align: center;
  }
`;

// The data reported is the one of the BQN selected, since the command
// carries its option, so there is nothing to filter out here.
const Result = ({data}) => {
  const bqnId = useBqnId();
  const barColor = "#006AB7";

  const sortedUsage = data.usage
    .slice()
    .sort((a, b) => parseFloat(a.bqnId) - parseFloat(b.bqnId));
  
  return (
    <UsageGraphLayout>
      <h4>Root disk partition</h4>
      <NVHorizontalBarChart
        key={`horizontal-bar-chart-${bqnId}`}
        valueUnits=""
        tooltipValueFormatter={(value) => `${formats.oneDecimal(value)} GB`}
        items={[
          {
            key: "Used",
            color: barColor,
            values: sortedUsage.map((item) => ({
                label: item.bqnId === undefined ? "" : `BQN ${item.bqnId}`,
                value: item.used,
              })),
          },
          {
            key: "Free",
            color: `${login.isTheme("light") ? "#cacaca" : "#3A3A3E"}`,
            values: sortedUsage.map((item) => ({
                label: item.bqnId === undefined ? "" : `BQN ${item.bqnId}`,
                value: item.free,
              })),
          },
        ]}
        showRoundCorners={false}
        showColors={true}
        barHeight={45}
        animationDuration={750}
      />
      <div className="centered">Gbytes</div>
    </UsageGraphLayout>
  );
};

export default Result;
